/* Tea Lab motion (Subtle and Full). Reads <html data-tl-motion>, set in layout/theme.liquid.
   Fades in the page sections that have no motion of their own (trust strip, FAQ page ...) as they scroll into view.
   Sections that already animate (home page, product, collection, cart ...) are not touched.
   Add data-tl-reveal to any other element to opt it in. Class .tl-mo is only added here, so with JS off nothing is hidden. */
(function () {
  var mode = document.documentElement.getAttribute('data-tl-motion') || 'subtle';
  window.TeaLabMotion = { mode: mode };
  if (mode === 'off') return;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce || !('IntersectionObserver' in window)) return;
  var SEL = '.tea-lab-brand-promise-section, .tea-lab-faq-hero-section, .tea-lab-faq-main-section, .tea-lab-faq-banner-section, .tea-lab-journal-preview-section, .tea-lab-social-grid-section, .tea-lab-reviews-section, .tea-lab-bundle-section, .tea-lab-collection-band-section, [data-tl-reveal]';

  function start() {
    if (window.Shopify && window.Shopify.designMode) return;
    var main = document.getElementById('MainContent');
    if (!main) return;
    var vh = window.innerHeight || 800;
    var list = Array.prototype.filter.call(main.querySelectorAll(SEL), function (el) {
      return el.getBoundingClientRect().top > vh * 0.92;
    });
    if (!list.length) return;

    function clean(el) {
      el.classList.remove('tl-mo', 'tl-mo-in');
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        /* in view, or already scrolled past (page opened part-way down): show it */
        if (!e.isIntersecting && e.boundingClientRect.top >= 0) return;
        var el = e.target;
        io.unobserve(el);
        el.classList.add('tl-mo-in');
        var done = false;
        var fin = function () { if (done) return; done = true; clean(el); };
        el.addEventListener('transitionend', function (t) { if (t.target === el && t.propertyName === 'opacity') fin(); });
        window.setTimeout(fin, 1400);
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -8% 0px' });

    list.forEach(function (el) { el.classList.add('tl-mo'); io.observe(el); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();